import { getAnalytics } from "@tm/insurance/analytics";
import {
  getSelectedCountriesFromLocalStorage,
  initializePageTracking,
  triggerPageExit,
} from "@tm/insurance/analytics/xdm";
import { pageStack, PAGE_NAME_CONSTANTS } from "@tm/insurance/navigation";
import { convertDateToUnix, convertUnixToDate } from "@tm/insurance/utils";
import { BreadcrumbComponent } from "@tm/static";
import { useEffect } from "react";
import { ComponentRenderer } from "../../../components/mypartner";
import { FilterProvider } from "../../../components/mypartner/contexts/FilterContext";
import { NetPriceProvider } from "../../../components/mypartner/contexts/NetPriceContext";
import { ListingPageV2Props } from "../types";
import {
  HeadComp,
  LeftComp,
  ListingLayoutV2,
  MainContainer,
  RightComp,
} from "./InsuranceListingV2.styles";

const InsuranceListingV2 = ({ listingData }: ListingPageV2Props) => {
  const { components, pageData } = listingData;
  const analytics = getAnalytics();

  useEffect(() => {
    pageStack.push(PAGE_NAME_CONSTANTS.LISTING);
    const queryParams = new URLSearchParams(window.location.search);

    const segment = queryParams.get("segment");
    const startDate = queryParams.get("startDate");
    const endDate = queryParams.get("endDate");
    const travellers = queryParams.get("travellers");
    const countries = queryParams.get("countries");

    const subpageName = queryParams.get("type");

    analytics?.trackPageLoadEvent({
      pageName: "LISTING",
      experiment: pageData?.experiment,
    });
    let selectedCountries = [];
    if (countries) {
      selectedCountries = getSelectedCountriesFromLocalStorage(
        queryParams.get("countries")?.split(",") || []
      );
    }
    let start, end;
    if (startDate && endDate) {
      start = convertUnixToDate(Number(startDate));
      end = convertUnixToDate(Number(endDate));
    }
    initializePageTracking(
      {
        page_context: {
          page_name: "listing",
          page_type: "funnel",
          funnel_step: "listing",
          ...(subpageName && { subpage_name: `${subpageName}_mypartner` }),
        },
      },
      {
        countries: selectedCountries,
        journeyType: segment || "",
        travellers: travellers ? parseInt(travellers) : 1,
        fromDateTime: start ? convertDateToUnix(start) : 0,
        toDateTime: end ? convertDateToUnix(end) : 0,
      }
    );
    return () => {
      triggerPageExit();
    };
  }, []);

  return (
    <FilterProvider>
      <NetPriceProvider>
        <ListingLayoutV2 id="pageId">
          <HeadComp>
            <BreadcrumbComponent />
            <ComponentRenderer components={components} layout="top" />
          </HeadComp>
          <MainContainer>
            <LeftComp>
              <ComponentRenderer components={components} layout="left" />
            </LeftComp>
            <RightComp>
              <ComponentRenderer
                components={components}
                csrfToken={pageData?.csrfToken}
                layout="right"
              />
            </RightComp>
          </MainContainer>
        </ListingLayoutV2>
      </NetPriceProvider>
    </FilterProvider>
  );
};

export default InsuranceListingV2;
